import React, { useEffect, useRef, useState } from "react";
import { VideoSeriesProps } from "../../store/actionType";
import EditSeries from "../EditSeries";
import FolderCard from "modules/video/components/FolderCard";
import MenuDropdown from "modules/video/components/MenuDropdown";
import { SmallScreenModel } from "components";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import { deleteVideoSeries } from "../../store/action";
import { connect, useSelector } from "react-redux";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

interface SeriesProps {
  seriesData: VideoSeriesProps;
  onClick: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & SeriesProps;
const SeriesCard: React.FC<Props> = ({
  seriesData,
  onClick,
  onDeleteVideoSeries,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEidtFormOpen, setIsEidtFormOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [deleteError, setDeleteError] = useState(null);
  const seriesState = useSelector(
    (state: any) => state.videoSeries?.videoSeriesState
  );
  const closeModel = () => {
    setIsEidtFormOpen(false);
  };
  const handleMenuClick = (e: any) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSeriesClick = () => {
    if (!isMenuOpen) {
      onClick();
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };
  const handleDeleteSeries = (e: any) => {
    e.stopPropagation();
    onDeleteVideoSeries(seriesData.id, seriesData.folder_id);
  };

  const toggleEditModal = () => {
    setIsEidtFormOpen(!isEidtFormOpen);
  };

  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  useEffect(() => {
    setDeleteError(seriesState.error);
    if (seriesState.error) {
    } else {
      setIsDeleteDialogOpen(false);
    }
  }, [seriesState.error]);

  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_SERIES));
  return (
    <>
      <FolderCard
        clickedFolder={handleSeriesClick}
        clickedMenu={handleMenuClick}
        title={seriesData.title}
        description={seriesData.series_order}
      >
        {isMenuOpen && (
          <>
            {isPermitted ? (
              <MenuDropdown
                clickedEdit={toggleEditModal}
                copyId={seriesData.id}
                clickedDelete={toggleDeleteDialog}
              />
            ) : (
              <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                You don't have the permission.
              </div>
            )}
          </>
        )}
      </FolderCard>
      <SmallScreenModel
        showModal={isEidtFormOpen}
        setShowModal={setIsEidtFormOpen}
      >
        <EditSeries closeModal={closeModel} seriesData={seriesData} />
      </SmallScreenModel>
      <SmallScreenModel
        showModal={isDeleteDialogOpen}
        setShowModal={setIsDeleteDialogOpen}
      >
        <ConfirmationDialogMsg
          title={"Delete Series"}
          message={"Are you sure you want to delete?"}
          onConfirm={handleDeleteSeries}
          onCancel={toggleDeleteDialog}
          folderName={seriesData.title}
          error={deleteError}
        />
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onDeleteVideoSeries: (series_id: string, folder_id: string) =>
    dispatch(deleteVideoSeries(series_id, folder_id)),
});

export default connect(null, mapDispatchToProps)(SeriesCard);
